import { routeName } from '~/@common/constants'

const SIGNATURE_WORKBOOK_LECTURES_PATH = routeName.bridge.signatureWorkbookLecture.split('/:')[0]

const isSignatureWorkbookLecturePath = (pathname: string): boolean =>
  pathname === SIGNATURE_WORKBOOK_LECTURES_PATH ||
  pathname.startsWith(`${SIGNATURE_WORKBOOK_LECTURES_PATH}/`)

// 외부 진입점 (deeplink / native iframe) — 마이그레이션이 redirect 하면 deeplink 흐름이 깨지므로 skip.
//   integration.* path 는 별개 — 각 핸들러에서 explicit 체크 (semantic 다름).
export const isIntegrationBridgePath = (pathname: string): boolean =>
  pathname === routeName.bridge.teacherIframe ||
  pathname === routeName.bridge.qr ||
  pathname === routeName.bridge.lecture ||
  isSignatureWorkbookLecturePath(pathname)
